import Vue from 'vue'
import Vuex from 'vuex'

import {router} from "../main.js"

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    home: {
      UserFullName: 'Guest',
      Greeting: 'Hi',
      Surveys: [],
      Stats: [],
      RecipeCategories: [],
    },
    currentLanguage: '',
    authToken: '',
    userData: JSON.parse(document.getElementById('config').innerHTML).userData,
    // userData: {
    //   username: '',
    //   password: '',
    // },

    surveyLoaded: false,
    currentSurvey: {},
    currentQuestionNum: 0,
    mySchedule: {},
    timeBlock: {},
    adviceDetail: {},
    timeFrameId: null,
    recipes: [],
    recipeDetail:{},
    tips: [],
    info: [],
    faq: [],
    content: {},
    dashboard: {},

    sidebarVisible: true,
    sidebarOpen: false,
    shiftClass: {
      typeId: [1,2,4,8,128],
      tr: {1: 'ochtend', 2: 'dag', 4: 'avond', 8: 'avond', 128: 'inactief'},
      td: {1: 'text-ochtend', 2: 'text-dag', 4: 'text-avond', 8: 'text-avond', 128: 'text-inactief'},
      box: {1: 'ochtend-box', 2: 'dag-box', 4: 'avond-box', 8: 'avond-box', 128: 'inactief-box'},
    },

  },
  getters: {
    getShiftClass: (state) => {
      return state.shiftClass
    },

    getCurrentLanguage: state => {
      return state.currentLanguage
    },
    getAuthToken: state => {
      return state.authToken
    },
    getUserData: state => {
      return state.userData
    },
    getHome: state => {
      return state.home
    },
    getDashboard: state => {
      return state.dashboard
    },

    getSidebarVisible: state => {
      return state.sidebarVisible
    },
    getSidebarOpen: state => {
      return state.sidebarOpen
    },

    getSurveys: state => {
      return state.home.Surveys
    },
    getSurveyLoaded: state => {
      return state.surveyLoaded
    },
    getCurrentSurvey: state => {
      return state.currentSurvey
    },
    getCurrentQuestionNum: state => {
      return state.currentQuestionNum
    },

    getMySchedule: state => {
      return state.mySchedule
    },
    getTimeBlock: state => {
      return state.timeBlock
    },
    getAdviceDetail: state => {
      return state.adviceDetail
    },

    getRecipes: state => {
      return state.recipes.CmsItems
    },
    getRecipeDetails: state => {
      return state.recipeDetail
    },
    getCategories: state => {
      return state.home.RecipeCategories
    },
    getTips: state => {
      return state.tips.CmsItems
    },
    getInfo: state => {
      return state.info.CmsItems
    },
    getFAQ: state => {
      return state.faq.CmsItems
    },
    getContent: state => {
      return state.content
    },
    getTimeFrame: state => {
      return state.timeFrameId
    },

  },
  mutations: {
    SET_CURRENT_LANGUAGE: (state, data) => {
      state.currentLanguage = data
      Vue.i18n.set(data)
    },
    SET_AUTH_TOKEN: (state, data) => {
      state.authToken = data
      Vue.http.headers.common['X-Auth-Token'] = data
    },
    SET_HOME: (state, data) => {
      state.home = data
    },
    SET_DASHBOARD: (state, data) => {
      state.dashboard = data
    },

    SET_MY_SCHEDULE: (state, data) => {
      state.mySchedule = data
    },
    SET_TIME_BLOCK: (state, data) => {
      state.timeBlock = data
    },
    SET_ADVICE_DETAIL: (state, data) => {
      state.adviceDetail = data
    },
    HIDE_ADVICE_DETAIL: (state) => {
      state.adviceDetail = null
    },

    SET_SIDEBAR_VISIBLE: (state, data) => {
      state.sidebarVisible = data
      if (data) {
        document.body.classList.add('sidebar-visible')
      } else {
        document.body.classList.remove('sidebar-visible')
      }
    },
    SET_SIDEBAR_OPEN: (state, data) => {
      state.sidebarOpen = data
      if (data) {
        document.body.classList.add('sidebar-open')
      } else {
        document.body.classList.remove('sidebar-open')
      }
    },
    SET_SURVEY_LOADED: (state, data) => {
      state.surveyLoaded = data
    },
    LOAD_CURRENT_SURVEY: (state, data) => {
      state.currentSurvey = data
    },
    SET_CURRENT_QUESTION_NUM: (state, num) => {
      state.currentQuestionNum = num
    },
    LOAD_RECIPES: (state, data) => {
      state.recipes = data
    },
    LOAD_RECIPE_DETAIL: (state, data) => {
      state.recipeDetail = data
    },
    LOAD_TIPS: (state, data) => {
      state.tips = data
    },
    LOAD_INFO: (state, data) => {
      state.info = data
    },
    LOAD_FAQ: (state, data) => {
      state.faq = data
    },
    LOAD_CONTENT: (state, data) => {
      state.content = data
    },
    SET_TIMEFRAME: (state, data) => {
      state.timeFrameId = data
    },

  },
  actions: {
    //
    // USER ACTIONS
    //
    userLogin: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        Vue.http.post('user/login', state.userData).then(response => {
          console.log('API: USER LOGIN')
          commit('SET_AUTH_TOKEN', response.data)
          resolve(response)
        }, error => {
          console.log('API ERROR: USER LOGIN')
          reject(error)
        })
      })
    },

    userLogout: ({ commit, state }) => {
      Vue.http.post('user/logout', state.userData).then(response => {
        console.log('API: USER LOGOUT', response.data)
      }, error => {
        console.log('API ERROR: USER LOGOUT', error.data)
      })
      commit('SET_AUTH_TOKEN', '')
      commit('LOAD_CURRENT_SURVEY', {})
      commit('SET_HOME', {
        UserFullName: 'Guest',
        Greeting: 'Hi',
        Surveys: [],
        Stats: [],
        RecipeCategories: [],
      })
    },

    preLoadHome: ({ commit, state, dispatch }) => {
      console.log('API: PRELOAD HOME')
      let languageReload = false
      Vue.http.get('home/' + state.currentLanguage).then(response => {
        if (state.currentLanguage !== response.data.PreferedLanguage) {
          languageReload = true
        }
        commit('SET_CURRENT_LANGUAGE', response.data.PreferedLanguage)
        if (!languageReload) {
          commit('SET_HOME', response.data)
        } else {
          dispatch('preLoadHome')
        }
      }, error => {
        console.log('API ERROR: PRELOAD HOME', error.data)
        dispatch('handleApiError', error)
      })
    },

    loadDashboard: ({ commit, state, dispatch }) => {
      console.log('API: LOAD DASHBOARD')
      // let languageReload = false
      Vue.http.get('dashboard/' + state.currentLanguage).then(response => {
        let diagramsT = []
        let diagrams = response.data.Diagrams
        diagrams.forEach(
          diagramS => {
            let diagramT = {}
            diagramT.Title = diagramS.Title
            diagramT.Description = diagramS.Description
            let chartData = [['date', 'score']]
            diagramS.DataPoints.forEach(dp => {
              chartData.push([dp.Key.substring(0,5), dp.Value])
            })
            diagramT.chartData = chartData
            diagramsT.push(diagramT)
          }
        )
        commit('SET_DASHBOARD', diagramsT)
      }, error => {
        console.log('API ERROR: PRELOAD DASHBOARD', error.data)
        dispatch('handleApiError', error)
      })
    },

    changeLanguage: ({ commit, state, dispatch }, lang) => {
      commit('SET_CURRENT_LANGUAGE', lang)
      Vue.http.post('user/setlanguage/' + lang).then(response => {
        console.log('API: USER CHANGE LANG')
        dispatch('preLoadHome')
      }, error => {
        console.log('API ERROR: USER CHANGE LANG')
        reject(error)
      })

    },

    userChangePassword: ({ commit }, userData) => {
      return new Promise((resolve, reject) => {
        Vue.http.post('user/changepassword', userData).then(response => {
          console.log('API: USER CHANGE PWD')
          resolve(response)
        }, error => {
          console.log('API ERROR: USER CHANGE PWD')
          reject(error)
        })
      })
    },

    contactSubmit: ({ commit }, userData) => {
      return new Promise((resolve, reject) => {
        Vue.http.post('user/contact', userData).then(response => {
          console.log('API: CONTACT')
          resolve(response)
        }, error => {
          console.log('API ERROR: CONTACT')
          reject(error)
        })
      })
    },

    userChangeEmail: ({ commit }, userData) => {
      return new Promise((resolve, reject) => {
        Vue.http.post('user/changeemail', userData).then(response => {
          console.log('API: USER CHANGE EMAIL')
          resolve(response)
        }, error => {
          console.log('API ERROR: USER CHANGE EMAIL')
          reject(error)
        })
      })
    },

    userLoadRegistration: ({ commit }, token) => {
      return new Promise((resolve, reject) => {
        Vue.http.get('registration/' + token).then(response => {
          console.log('API: LOAD REGISTRATION')
          resolve(response)
        }, error => {
          console.log('API ERROR: LOAD REGISTRATION')
          reject(error)
        })
      })
    },

    userSendRegistration: ({ commit }, userData) => {
      return new Promise((resolve, reject) => {
        Vue.http.post('registration/send', userData).then(response => {
          console.log('API: SEND REGISTRATION')
          commit('SET_AUTH_TOKEN', response.data)
          resolve(response)
        }, error => {
          console.log('API ERROR: SEND REGISTRATION')
          reject(error)
        })
      })
    },

    //
    // SURVEY ACTIONS
    //
    saveSurveyAnswer: ({ commit, dispatch }, saveData) => {
      // Vue.http.post('survey/saveanswer', saveData).then(response => {
      let answer = (saveData.answer === null) ? '' : saveData.answer
      Vue.http.post('survey/saveanswer?sid=' + saveData.sid + '&questionId=' + saveData.questionId + '&answer=' + answer).then(response => {
        console.log('API: SAVE ANSWER', response.data)
      }, error => {
        console.log('API ERROR: SAVE ANSWER', error)
        dispatch('handleApiError', error)
      })
    },
    handleApiError: ({ commit, dispatch }, error) => {
      if(error.status != 401) return
      dispatch('userLogout')
      router.push('/login')
    },
    setSurveyStatus: ({ commit, dispatch }, saveData) => {
      Vue.http.post('survey/setstatus', saveData).then(response => {
        console.log('API: SET STATUS', response.data)
      }, error => {
        console.log('API ERROR: SET STATUS', error.data)
        dispatch('handleApiError', error)
      })
    },

    loadCurrentSurvey: ({ commit, state, dispatch }, surveyId) => {
      Vue.http.get('survey/' + state.currentLanguage + '/sid/' + surveyId).then(response => {
        console.log('API: LOAD CURRENT SURVEY')
        commit('LOAD_CURRENT_SURVEY', response.data)
        commit('SET_SURVEY_LOADED', true)
        let currentQ = response.data.Questions.findIndex((obj => obj.Id === response.data.CurrentQuestionId))
        if (currentQ < 0) {currentQ = 0}
        commit('SET_CURRENT_QUESTION_NUM', currentQ)
      }, error => {
        console.log('API ERROR: LOAD CURRENT SURVEY', error.data)
        dispatch('handleApiError', error)
      })
    },

    //
    // SCHEDULE ACTIONS
    //
    loadMySchedule: ({ commit, state, dispatch }, weekData) => {
      let paramStr = state.currentLanguage
      if (weekData) {
        paramStr += '/year/' + weekData.year + '/week/' + weekData.week + '/jump/0'
      }

      Vue.http.get('myschedule/' + paramStr).then(response => {
        console.log('API: LOAD MYSCHEDULE')
        commit('SET_MY_SCHEDULE', response.data)
      }, error => {
        console.log('API ERROR: LOAD MYSCHEDULE', error.data)
        dispatch('handleApiError', error)
      })
    },

    jumpMySchedule: ({ commit, state, dispatch }, jumpData) => {
      Vue.http.get('myschedule/' + state.currentLanguage + '/year/' + jumpData.year + '/week/' + jumpData.week + '/jump/' + jumpData.jump).then(response => {
        console.log('API: JUMP MYSCHEDULE')
        commit('SET_MY_SCHEDULE', response.data)
      }, error => {
        console.log('API ERROR: JUMP MYSCHEDULE', error.data)
        dispatch('handleApiError', error)
      })
    },

    saveMySchedule: ({ commit, dispatch }, saveData) => {
      return new Promise((resolve, reject) => {
        Vue.http.post('myschedule/year/' + saveData.year + '/week/' + saveData.week + '/day/' + saveData.day + '/selected/' + saveData.selected).then(response => {
          console.log('API: SAVE MYSCHEDULE')
          resolve(response)
        }, error => {
          console.log('API ERROR: SAVE MYSCHEDULE')
          dispatch('handleApiError', error)
          reject(error)
        })
      })
    },

    loadTimeBlockAdvice: ({ commit, state, dispatch }, shift) => {
      return new Promise((resolve, reject) => {
        Vue.http.get('timeblockadvice/' + state.currentLanguage + '/shift/' + shift).then(response => {
          console.log('API: LOAD TIMEBLOCK ADVICE')
          commit('SET_TIME_BLOCK', response.data)
          resolve(response)
        }, error => {
          console.log('API ERROR: LOAD TIMEBLOCK ADVICE', error.data)
          dispatch('handleApiError', error)
          reject(error)
        })
      })
    },

    loadAdviceDetails: ({ commit, state, dispatch }, {adviceId, timeframeId}) => {
      return new Promise((resolve, reject) => {
        Vue.http.get('advices/details/' + state.currentLanguage + '/id/' + adviceId + '/timeframe/' + timeframeId).then(response => {
          console.log('API: LOAD ADVICE DETAIL')
          commit('SET_ADVICE_DETAIL', response.data)
          resolve(response)
        }, error => {
          console.log('API ERROR: LOAD ADVICE DETAIL', error.data)
          dispatch('handleApiError', error)
          reject(error)
        })
      })
    },

    //
    // RECIPES ACTIONS
    //
    loadCategoryRecipes: ({ commit, state, dispatch }, categoryId) => {
      Vue.http.get('recipe/' + state.currentLanguage + '/categoryid/' + categoryId).then(response => {
        console.log('API: LOAD CATEGORY RECIPES')
        commit('LOAD_RECIPES', response.data)
      }, error => {
        console.log('API ERROR: LOAD CATEGORY RECIPES', error.data)
        dispatch('handleApiError', error)
      })
    },

    loadRecipeDetails: ({ commit, state, dispatch }, recipeId) => {
      Vue.http.get('recipes/details/' + state.currentLanguage + '/id/' + recipeId).then(response => {
        console.log('API: LOAD RECIPE DETAIL')
        commit('LOAD_RECIPE_DETAIL', response.data)
      }, error => {
        console.log('API ERROR: LOAD RECIPE DETAIL', error.data)
        dispatch('handleApiError', error)
      })
    },

    //
    // INFO ACTIONS
    //
    loadTips: ({ commit, state, dispatch }) => {
      Vue.http.get('tip/' + state.currentLanguage).then(response => {
        console.log('API: LOAD TIPS')
        commit('LOAD_TIPS', response.data)
      }, error => {
        console.log('API ERROR: LOAD TIPS', error.data)
        dispatch('handleApiError', error)
      })
    },

    loadInfo: ({ commit, state, dispatch }) => {
      Vue.http.get('info/' + state.currentLanguage).then(response => {
        console.log('API: LOAD INFO')
        commit('LOAD_INFO', response.data)
      }, error => {
        console.log('API ERROR: LOAD INFO', error.data)
        dispatch('handleApiError', error)
      })
    },

    loadFAQ: ({ commit, state, dispatch }) => {
      Vue.http.get('faq/' + state.currentLanguage).then(response => {
        console.log('API: LOAD FAQ')
        commit('LOAD_FAQ', response.data)
      }, error => {
        console.log('API ERROR: LOAD FAQ', error.data)
        dispatch('handleApiError', error)
      })
    },

    loadContent: ({ commit, state, dispatch }, name) => {
      Vue.http.get('content/' + state.currentLanguage + '/name/' + name).then(response => {
        console.log('API: LOAD CONTENT')
        commit('LOAD_CONTENT', response.data)
      }, error => {
        console.log('API ERROR: LOAD CONTENT', error.data)
        dispatch('handleApiError', error)
      })
    },

  }
});



// WEBPACK FOOTER //
// ./src/state/store.js